import EmptyState from "../common/EmptyState";

export default function VencimientosPanel({ items = [] }) {
    return (
        <div>
            <h3>Próximos vencimientos</h3>
            {!items.length ? (
                <EmptyState title="Sin vencimientos" message="No hay vencimientos próximos." />
            ) : (
                <ul className="simple-list">
                    {items.map((item, i) => (
                        <li key={item.id || i}>
                            <strong>{item.concepto || item.titulo}</strong>
                            <p>{item.fechaVencimiento} - {item.monto}</p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}